<template>
	<div class="article analysis">
		<div class="card">
			<h5>Articles</h5>

			<div class="preview">
				<div class="thumbnail" v-for="a in article"
					:key="a.id"
					v-if="getContent('article', a.id)">
					<span class="count"><span>{{ a.event.length }}</span></span>
					<img :src="getContentKey('article', a.id, 'image')" style="min-height:80px">
					<p>{{ getContentKey('article', a.id, 'title') }}</p>
					<small>Last read {{ formatDate(a.event[a.event.length - 1].created) }}</small>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'

import format from '@/module/util/format'

export default {
	name: 'patient-article-card-analysis',

	props: {
		article: {
			type: Array,
			required: true
		},
		category: {
			type: String,
			required: true
		}
	},

	methods: {
		...format
	},

	computed: {
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		])
	}
}
</script>

<style lang="scss" scoped>
@import "../component/table/style/analysis.scss";
.preview {
	white-space: nowrap;
	overflow-x: scroll;

	.thumbnail {
		width: 140px;
		margin-right: 10px;
		display: inline-block;
		vertical-align: top;
		position: relative;

		.count {
			position: absolute;
			left: 0;
			top: 20px;
			width: 100%;
			text-align: center;

			span {
				display: block;
				margin: 0 auto;
				width: 40px;
				height: 40px;
				line-height: 40px;
				border-radius: 20px;
				opacity: 0.8;
				font-size: 20px;
				color: white;
				background: #833e93;
			}
		}

		img {
			width: 100%;
		}
		p {
			font-weight: 500;
			white-space: normal;
		}
		small {
			color: #5f5f5f;
		}
	}
}
</style>
